module.exports = __webpack_public_path__ + "images/emoji/1234.d51c6150155da54b8a1c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/1234.png
// module id = Z0fM
// module chunks = 1